import { render, staticRenderFns } from "./StatMenu.vue?vue&type=template&id=15457ffb&scoped=true&"
import script from "./StatMenu.vue?vue&type=script&lang=js&"
export * from "./StatMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15457ffb",
  null
  
)

export default component.exports